import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LocationSolidIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LocationSolidIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 2.5016C7.7197 2.5016 4.24984 5.97145 4.24984 10.2517C4.24984 16.3677 12 21.4983 12 21.4983C12 21.4983 19.7501 16.3677 19.7501 10.2517C19.7501 5.97145 16.2802 2.5016 12 2.5016ZM12 13.1058C10.4237 13.1058 9.14586 11.828 9.14586 10.2517C9.14586 8.67541 10.4237 7.39761 12 7.39761C13.5763 7.39761 14.8541 8.6754 14.8541 10.2517C14.8541 11.828 13.5763 13.1058 12 13.1058Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0001 22C11.9036 22 11.8071 21.9721 11.7234 21.9167C11.3977 21.7012 3.74854 16.5646 3.74854 10.2515C3.74854 5.70164 7.45017 2 12.0001 2C16.55 2 20.2516 5.70164 20.2516 10.2515C20.2516 16.5646 12.6025 21.7012 12.2768 21.9167C12.193 21.9721 12.0966 22 12.0001 22ZM12.0001 3.00304C8.00312 3.00304 4.75157 6.25458 4.75157 10.2515C4.75157 15.3838 10.641 19.9107 12.0001 20.8868C13.3592 19.9107 19.2486 15.3838 19.2486 10.2515C19.2486 6.25458 15.997 3.00304 12.0001 3.00304ZM12.0001 13.6074C10.1497 13.6074 8.64422 12.1019 8.64422 10.2516C8.64422 8.40123 10.1498 6.89618 12.0001 6.89618C13.8504 6.89618 15.3554 8.40123 15.3554 10.2516C15.3554 12.1019 13.8504 13.6074 12.0001 13.6074ZM12.0001 7.89921C10.7027 7.89921 9.64725 8.95466 9.64725 10.2515C9.64725 11.5489 10.7027 12.6044 12.0001 12.6044C13.297 12.6044 14.3524 11.5489 14.3524 10.2515C14.3524 8.95465 13.297 7.89921 12.0001 7.89921Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LocationSolidIcon;
